import { Search } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const EXPERTISE_FILTERS = [
  { key: "all", label: "All Ways to Help" },
  { key: "story", label: "Share my experience/story" },
  { key: "outreach", label: "Community outreach" },
  { key: "listen", label: "Listen/support people affected by bias" },
  { key: "legal", label: "Legal expertise" },
  { key: "mental_health", label: "Mental health/wellness expertise" },
  { key: "business", label: "Business/professional expertise" },
  { key: "tech", label: "Technology/data" },
  { key: "comms", label: "Communications/social media" },
  { key: "fundraising", label: "Fundraising" },
  { key: "organizing", label: "Community organizing" },
  { key: "research", label: "Research/education" },
  { key: "connect", label: "Introduce/connect to people or organizations" },
  { key: "anywhere", label: "Volunteer wherever needed" },
  { key: "other", label: "Other" },
];

export function VolunteerFilterBar({ search, onSearchChange, expertise, onExpertiseChange }) {
  return (
    <div className="flex flex-col sm:flex-row gap-3 mb-5">
      <div className="relative flex-1 max-w-sm">
        <Search className="h-4 w-4 text-zinc-400 absolute left-3 top-1/2 -translate-y-1/2" />
        <Input
          placeholder="Search name or email" value={search} onChange={(e) => onSearchChange(e.target.value)}
          data-testid="admin-volunteers-search-input"
          className="bg-white border-zinc-300 text-zinc-950 rounded-none pl-9 focus:ring-1 focus:ring-[#4FD1C5]"
        />
      </div>
      <Select value={expertise} onValueChange={onExpertiseChange}>
        <SelectTrigger data-testid="admin-volunteers-expertise-filter" className="bg-white border-zinc-300 text-zinc-950 rounded-none focus:ring-1 focus:ring-[#4FD1C5] sm:w-64">
          <SelectValue />
        </SelectTrigger>
        <SelectContent className="bg-white border-zinc-200 text-zinc-950">
          {EXPERTISE_FILTERS.map((f) => (
            <SelectItem key={f.key} value={f.key} data-testid={`admin-volunteers-expertise-filter-${f.key}`}>{f.label}</SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
